import { useEffect, useState } from 'react';
import { User, signOut, onAuthStateChanged } from 'firebase/auth';
import { auth } from '../services/firebaseAuth';
import { 
  IconButton, 
  Avatar, 
  Box, 
  Menu, 
  MenuItem, 
  ListItemIcon, 
  Typography,
  ThemeProvider,
  createTheme
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import api from 'services/api';
import { ADALONG_COLORS } from '../styles';

const theme = createTheme({
  components: {
    MuiList: {
      styleOverrides: {
        root: {
          backgroundColor: ADALONG_COLORS.DARK_BLACK,
          color: 'white',
        },
      },
    },
  },
});

export function UserPill() {
  const [user, setUser] = useState<User | null>(auth.currentUser);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
    });

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, []);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSignOut = async () => {
    await signOut(auth);
    await api.logout();
    window.location.href = '/';
  };

  if (!user) {
    return (
      <Box onClick={handleSignOut} sx={{ cursor: 'pointer' }}>
        <LogoutIcon sx={{ color: ADALONG_COLORS.LIGHT_WHITE }} />
      </Box>
    );
  }

  return (
    <Box sx={boxStyle}>
      <Typography sx={{ minWidth: 200, color: ADALONG_COLORS.LIGHT_WHITE }}>
        Hello, {user.displayName || user.email}
      </Typography>
      <IconButton
        onClick={handleClick}
        size="small"
        sx={{ ml: 2 }}
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        {user.photoURL ? (
          <Avatar src={user.photoURL} />
        ) : (
          <PersonIcon sx={{ color: ADALONG_COLORS.LIGHT_WHITE }} />
        )}
      </IconButton>
      <ThemeProvider theme={theme}>
        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{ elevation: 0, sx: { menuStyle } }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem onClick={handleSignOut} sx={menuItemStyle}>
            <ListItemIcon sx={iconStyle}>
              <LogoutIcon fontSize="small" />
            </ListItemIcon>
            Logout
          </MenuItem>
        </Menu>
      </ThemeProvider>
    </Box>
  );
}

const menuItemStyle = {
  '&:hover': {
    backgroundColor: ADALONG_COLORS.LIGHT_BLACK,
  },
};

const iconStyle = {
  color: 'white',
};

const boxStyle = {
  display: 'flex',
  alignItems: 'center',
  textAlign: 'right',
};

const menuStyle = {
  overflow: 'visible',
  filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
  mt: 1.5,
  backgroundColor: ADALONG_COLORS.DARK_BLACK,
  '& .MuiAvatar-root': {
    width: 32,
    height: 32,
    ml: -0.5,
    mr: 1,
  },
};

